import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import MarketoForm from './MarketoForm'
import withCta from 'LiveBoard/components/shared/CallToAction/types/forms/withCta'
import merge from 'lodash/merge'
import get from 'lodash/get'

import './style.css.scss'

const MarketoFormContainer = (props) => {
  const lead = useSelector(state => state.lead)

  const handleSubmit = (values, formFields, successMessage, redirectUrl) => {
    const formData = merge(values, props.getCtaParams())

    return props.onSubmit(formData, formFields, successMessage, redirectUrl)
  }

  const getAutofillData = () => {
    const { name, last_name, email, company, phone, country, state } = lead
    return lead.anon_guest
      ? {}
      : { name, last_name, email, company, phone, country, state }
  }

  return (
    <MarketoForm
      config={props.config}
      onSubmit={handleSubmit}
      autoFillData={getAutofillData()} />
  )
}

MarketoFormContainer.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  itemId: PropTypes.number,
  onSubmit: PropTypes.func
}

export default withCta(MarketoFormContainer)